import "magnific-popup";
import Swal from "sweetalert2";
import {getCsrfToken} from "../../plugins/get-csrf-token";

export function attachCloudFilePopup($context) {
    if (!$context.length) {
        return;
    }

    $context.on('click', '.cloud-component-popup', function (event) {
        event.preventDefault();

        const cloudModalId = $(this).data('cloud-modal-id');
        const cloudModal = document.getElementById(cloudModalId);
        const cloudFilesListUrl = $(this).data('cloud-files-list-url');

        $(cloudModal)
            .modal('show')
            .css('z-index', 1041)
            .find('.modal-content')
            .html('<div class="m-5 text-center">' +
                '<div class="spinner-border mb-3" role="status"></div>' +
                '<strong class="d-block">Loading data, please wait...</strong>' +
                '</div>')
            .load(cloudFilesListUrl, function (responseText, textStatus) {
                if ('error' === textStatus) {
                    return $(this).html(responseText);
                }


            });
    });

    $context
        .on('click', '.cloud-component-image-magnific-popup', function (event) {
            event.preventDefault();
            $.magnificPopup.open({
                type: "image",
                closeOnContentClick: true,
                closeBtnInside: false,
                fixedContentPos: true,
                mainClass: "mfp-no-margins mfp-with-zoom",
                image: {
                    verticalFit: true,
                },
                items: {
                    src: $(this).data('image-url'),
                },
            });
        })
        .on('click', ".cloud-component-select", function (event) {
            event.preventDefault();

            const cloudFileId = $(this).data('cloud-file-id');
            const cloudFileUrlSmall = $(this).data('cloud-file-url-small');
            const cloudComponentId = $(this).closest('.modal').data('cloud-component-id');
            const cloudFileInputId = $(this).closest('.modal').data('cloud-input-id');
            const cloudDivId = $(this).closest('.modal').data('cloud-div-id');
            const cloudFileInputNameId = $(this).closest('.modal').data('cloud-input-name-id');
            const cloudFileOriginalName = $(this).data('cloud-file-original-name');
            const $cloudImageDiv = $(document.getElementById(cloudDivId));

        $cloudImageDiv.html('<img src="' + cloudFileUrlSmall + '" class="cloud-component-image">');
        setSelectedImage($context, cloudFileId, cloudFileInputId, cloudFileInputNameId, cloudFileOriginalName, cloudComponentId);

        if ($context.find("#" + cloudFileInputId).hasClass('copyToAdditionalData')) {
            const $cloudComponentPopup = $cloudImageDiv.closest('.survey-item')
                .find('.row:nth-child(2)')
                .find('.cloud-component-popup');
            const cloudDivId = $cloudComponentPopup.data('cloud-div-id');
            const cloudFileInputId = $cloudComponentPopup.data('cloud-input-id');
            const cloudFileInputNameId = $cloudComponentPopup.data('cloud-input-name-id');
            const cloudComponentId = $cloudComponentPopup.data('cloud-component-id');

            $(document.getElementById(cloudDivId))
                .html('<img src="' + cloudFileUrlSmall + '" class="cloud-component-image">');
            setSelectedImage($context, cloudFileId, cloudFileInputId, cloudFileInputNameId, cloudFileOriginalName, cloudComponentId);
        }
    });

    function setSelectedImage($context, cloudFileId, cloudFileInputId, cloudFileInputNameId, cloudFileOriginalName, cloudComponentId) {
        $context.find("#" + cloudFileInputId).attr('value', cloudFileId);
        $context.find("." + cloudFileInputNameId + " input").val(cloudFileOriginalName.split('.').slice(0, -1).join('.'));

        $context.find(".cloud-component-popup." + cloudComponentId).addClass('hide');
        $context.find(".cloud-component-upload." + cloudComponentId).addClass('hide uploaded');
        $context.find(".cloud-component-remove." + cloudComponentId).removeClass('hide');
        $context.find(".cloud-component-change-video-image." + cloudComponentId).removeClass('hide');
        $context.find('.stimuliAdditionalData').removeClass('hide');
    }

    $context.on('click', ".cloud-component-remove-file", function (event) {
        event.preventDefault();

        Swal.fire({
            title: 'Remove',
            text: 'Do you really want to delete this file?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: '<i class="label-icon bx bx-trash"></i> Delete',
            confirmButtonClass: 'btn btn-label btn-danger btn-min-width',
            cancelButtonText: '<i class="label-icon bx bx-arrow-back"></i> Cancel',
            cancelButtonClass: 'btn btn-label btn-primary btn-min-width',
        }).then((result) => {
            if (result.value === true) {
                const deleteItem = $(this).closest('.card').parent();
                $.ajax({
                    type: "DELETE",
                    headers: {'X-CSRF-TOKEN': getCsrfToken()},
                    url: $(this).attr('href'),
                    success: function () {
                        deleteItem.remove();
                    },
                    error: function (xhr, status, error) {
                        Swal.fire({
                            type: 'error',
                            title: 'Error',
                            text: error.message,
                        });
                    },
                    async: true,
                    cache: false,
                    contentType: false,
                    processData: false,
                    timeout: 60000
                });
            }
        })
    });
}
